// Пробное занятие: фиксированная цена и длительность для преподавателей с trial_enabled
export const TRIAL_LESSON_PRICE = 249
export const TRIAL_LESSON_DURATION = 25

export const formatTrialPrice = () => `${TRIAL_LESSON_PRICE.toLocaleString('ru-RU')} ₽`
